import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import theme from '@styles/theme';

interface IFileUpdate {
  onSelect: (type: 'default' | 'user') => void;
}

const ProfileUpdateList = ({ onSelect }: IFileUpdate) => {
  const { t } = useTranslation();
  const onSelectType = (type: 'default' | 'user') => {
    onSelect(type);
  };

  return (
    <div css={container}>
      <div className="title">{t('chat_popup_title_edit_profile')}</div>
      <div className="button-container">
        <button className="button" onClick={() => onSelectType('user')}>
          {t('chat_popup_title_profile_fix_image')}
        </button>
        <button className="button" onClick={() => onSelectType('default')}>
          {t('chat_popup_label_change_default_photo')}
        </button>
      </div>
    </div>
  );
};

const container = css`
  width: 100%;
  padding: 2em;
  border-radius: 12px;
  background-color: white;
  z-index: 2;

  .title {
    font-family: 'Apple SD Gothic Neo';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 24px;
  }

  .button {
    background: ${theme.colors.gray200};
    color: ${theme.colors.gray700};
    font-family: 'Apple SD Gothic Neo';
    font-style: normal;
    font-weight: 700;

    font-size: 16px;
    line-height: 24px;
    border-radius: 6px;
    padding: 12px 0;
    gap: 10px;
    cursor: pointer;
  }
`;

export default ProfileUpdateList;
